import React from 'react'
import Button from '../Button'
import { Container } from './styles'

const Pagination: React.FC<PaginationProps> = ({ meta, links, onChange }) => {
  const need = meta.last_page !== 1

  if (!need) {
    return null
  }

  return (
    <Container>
      <Button
        label="<<"
        onClick={() => onChange(links.first)}
        disabled={meta.current_page === 1}
      />
      <Button
        label="<"
        onClick={() => onChange(links.prev)}
        disabled={meta.current_page === 1}
      />
      {'página ' + meta.current_page + ' de ' + meta.last_page}

      <Button
        label=">"
        onClick={() => onChange(links.next)}
        disabled={meta.current_page === meta.last_page}
      />
      <Button
        label=">>"
        onClick={() => onChange(links.last)}
        disabled={meta.current_page === meta.last_page}
      />
    </Container>
  )
}

interface PaginationProps {
  meta: any
  links: any
  onChange: any
}

export default Pagination
